import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';
import { inputStyle } from '../lib/ui.js';

// ─── Override Audit (Round 21) — spec §13 ──────────────────────────────────
export function OverrideAuditView({ currentUser }) {
  const headers = { 'x-user-id': String(currentUser.id) };
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [error, setError] = useState('');

  async function load() {
    setLoading(true); setError('');
    try {
      const r = await api('GET', '/api/override-audit', null, headers);
      setEvents(r.events || []);
    } catch (e) { setError(e.message || 'Failed'); }
    finally { setLoading(false); }
  }
  useEffect(() => { load(); }, []);

  const filtered = filter
    ? events.filter((e) => (e.event_type || '').includes(filter) ||
                            (e.performed_by_name || '').toLowerCase().includes(filter.toLowerCase()) ||
                            (e.employee_name || '').toLowerCase().includes(filter.toLowerCase()))
    : events;

  const eventLabels = {
    manual_reduction_edit: 'Reduction edit',
    late_tor_override: 'Late TOR override',
    blackout_tor_approval: 'Blackout TOR',
    ot_cap_override: 'OT cap override',
    publish_race_win: 'Publish race',
    borrow_approved: 'Borrow approved',
    reliability_incident_voided: 'Incident voided',
  };

  return (
    <div className="space-y-3">
      <div className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
        <div>
          <div className="text-base font-semibold">Override audit</div>
          <div className="text-xs text-gray-500">Every policy bypass logged here. Filter by event type, manager, or employee name.</div>
        </div>
        <input value={filter} onChange={(e) => setFilter(e.target.value)}
          placeholder="Filter…" style={{ ...inputStyle, flex: '0 1 240px' }} />
      </div>
      {error && <div className="card" style={{ borderLeft: '4px solid #c62828' }}>
        <div className="text-xs text-red-700">{error}</div>
      </div>}
      {loading && <div className="card text-sm text-gray-500">Loading…</div>}
      {!loading && filtered.length === 0 && (
        <div className="card text-sm text-gray-500">No matching audit events.</div>
      )}
      {filtered.length > 0 && (
        <div className="card" style={{ padding: 0 }}>
          <table style={{ width: '100%', fontSize: 12 }}>
            <thead style={{ background: '#fafbfc', borderBottom: '1px solid #e0e0e0' }}>
              <tr style={{ color: '#757575', textAlign: 'left' }}>
                <th style={{ padding: '6px 10px' }}>When</th>
                <th style={{ padding: '6px 10px' }}>Event</th>
                <th style={{ padding: '6px 10px' }}>By</th>
                <th style={{ padding: '6px 10px' }}>Subject</th>
                <th style={{ padding: '6px 10px' }}>Location</th>
                <th style={{ padding: '6px 10px' }}>Reason</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((e) => (
                <tr key={e.id} style={{ borderBottom: '1px solid #fafafa' }}>
                  <td style={{ padding: '6px 10px', whiteSpace: 'nowrap', color: '#757575' }}>{e.created_at?.slice(0, 16)}</td>
                  <td style={{ padding: '6px 10px', fontWeight: 600 }}>{eventLabels[e.event_type] || e.event_type}</td>
                  <td style={{ padding: '6px 10px' }}>{e.performed_by_name || '—'}</td>
                  <td style={{ padding: '6px 10px' }}>{e.employee_name || '—'}</td>
                  <td style={{ padding: '6px 10px' }}>{e.location_name || '—'}</td>
                  <td style={{ padding: '6px 10px', color: '#9e9e9e' }}>{e.reason || ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
